import { Directive, ElementRef, HostListener } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';
import {AppConfig} from '../../app/app.config';

@Directive({
  selector: '[appPinchZoom]',
  standalone: false,
})
export class PinchZoomDirective {
  scaling: boolean = false;

  constructor(private elementRef: ElementRef<HTMLImageElement>,
    private readonly eventLogger: EventLoggerService,
    protected readonly appConfig: AppConfig) {}

  @HostListener('touchstart', ['$event'])
  touchStart(event: TouchEvent): void {
    if (event.touches.length !== 2) return;
    this.scaling = true;
  }

  @HostListener('touchmove', ['$event'])
  touchMove(event: TouchEvent): void {
    if (!this.scaling) return;
    this.elementRef.nativeElement.style.transform = 'scale(1.3)';
    this.elementRef.nativeElement.style.transition = 'transform 1s';
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'image-pinch-zoom' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  @HostListener('touchend', ['$event'])
  touchEnd(event: TouchEvent): void {
    this.elementRef.nativeElement.style.transform = 'scale(1)';
    this.elementRef.nativeElement.style.transition = 'unset';
    this.scaling = false;
  }
}
